import React, {Fragment, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getCampaignCodes, uploadCampaignCodes} from "../../../Api/ApiCalls";
import PaginationControls from "../../../components/PaginationControls";
import SearchBox from "../../../components/Common/SearchBox";
import UploadCodesModal from "../../../components/CampaignCode/CampaignCodesUploadModal";
import {handleError} from "../../../utils/SharedFunctions";
import {toast} from "react-toastify";
import {formatDate} from "../../../utils/dateUtils";

const CampaignCodesListPage = () => {
    const [campaignCodes, setCampaignCodes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [showUploadModal, setShowUploadModal] = useState(false);

    const fetchCampaignCodes = async (search = "", page = 1) => {
        setLoading(true);
        try {
            const response = await getCampaignCodes(search, page);
            setCampaignCodes(response.items);
            setTotalPages(response.totalPages || 1);
        } catch (error) {
            console.error("Error fetching campaign codes:", error);
        }
        setLoading(false);
    };

    const handleSearch = (term) => {
        setCurrentPage(1);
        setSearchTerm(term);
        fetchCampaignCodes(term, 1).then();
    };

    const handleUploadCodes = async (file) => {
        try {
            const formData = new FormData();
            formData.append("file", file);
            await uploadCampaignCodes(formData)
            toast.success("We received your file. It will be processed, and a report will be sent to your email shortly.");
            fetchCampaignCodes().then();

        } catch (error) {
            if(error.response?.status=== 500){
                toast.error("Failed to upload campaign codes. Please make sure your CSV file is valid and correctly formatted.");
            }
            handleError(error);
        }
        finally {
            setShowUploadModal(false)
        }
    };

    // Initial fetch
    useEffect(() => {
        fetchCampaignCodes(searchTerm, currentPage).then();
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchCampaignCodes(searchTerm, page).then();
    };
    return (
        <>
            <Fragment>
                <div className="row justify-content-center">
                    <div className="col-xl-12 col-xxl-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="d-flex justify-content-between align-items-center w-100">
                                    <h4 className="card-title mb-0">Campaign Codes</h4>
                                    <div className="d-flex gap-2">
                                        <Link to="/campaign-codes/add" className="btn btn-primary">
                                            + Add Campaign Code
                                        </Link>
                                        <button
                                            className="btn btn-outline-primary"
                                            onClick={() => setShowUploadModal(true)}>
                                            📤 Upload Codes
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <SearchBox
                                    placeholder=" Campaign Code:"
                                    onSearch={(term) => handleSearch(term)}
                                    buttonLabel="Search"
                                />

                                {loading ? (
                                    <p>Loading...</p>
                                ) : (
                                    <table className="table dataTable display">
                                        <thead>
                                        <tr>
                                            <th>Code</th>
                                            <th>Campaign Name</th>
                                            <th>Type</th>
                                            <th>Expiration</th>
                                            <th>Redeem Before</th>
                                            <th>Usage</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {campaignCodes.length ? (
                                            campaignCodes.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.code}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.type}</td>
                                                    <td>{formatDate(item.expirationDate)}</td>
                                                    <td>{formatDate(item.redeemBeforeDate)}</td>
                                                    <td>{item.usageCount || 0}</td>
                                                    <td>
                                                        <Link to={`/campaign-codes/edit/${item.id}`}
                                                              className="btn btn-sm btn-secondary">
                                                            Edit
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    No campaign codes found.
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                )}
                                {/* Pagination Component */}
                                <PaginationControls
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            <UploadCodesModal
                show={showUploadModal}
                onClose={() => setShowUploadModal(false)}
                onUpload={handleUploadCodes}
            />
            </>
    );
};

export default CampaignCodesListPage;